import ReactDOM from "react-dom/client";
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "/node_modules/primeflex/primeflex.css";
import "../src/Scss/dataTable.scss";
import "../src/Scss/contextmenu.scss";
import "../src/Scss/confirm-popup.scss";
import "../src/Scss/dropdown.scss";
import "../src/Scss/datepicker.scss";
import "../src/Scss/dialog.scss";
import "../src/Scss/form.scss";
import "../src/Scss/searchfilter.scss";
import "../src/Scss/quillImageAlign.scss";
import "./index.scss";
import '@fontsource/noto-sans';


import App from "./App";
import { bootstrapMarketplaceOAuthCallbackRoute } from "./Pages/Marketplace/marketplaceOAuthBootstrap";
import { HashRouter } from "react-router-dom";
import { useState, useEffect } from "react";
import { i18nReady } from "./Translations/i18n";
import { applyCachedBrowserBranding, loadAndApplyBrowserBranding } from "./Template/custom-styling/applyBrowserBranding";
import { prepareUrlSpecificStyling } from "./Template/custom-styling/urlSpecificStyling";
import { installChunkErrorReload } from "./Util/lazyWithRetry";
import secureLocalStorage from "react-secure-storage";
import * as StorageConstants from "./Models/SecureStorageConstants";

applyCachedBrowserBranding();
bootstrapMarketplaceOAuthCallbackRoute();
// Lazy route chunks: a stale chunk after a deploy triggers one automatic reload
// instead of a blank page (see Util/lazyWithRetry).
installChunkErrorReload();

const AppLoader = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const brandingReady = i18nReady
      .then(() => loadAndApplyBrowserBranding())
      .catch(() => loadAndApplyBrowserBranding());
    // Not signed in → the first thing on screen is a pre-login page (sign-in, share,
    // ...). Resolve the customer's URL-specific CSS in parallel so that page paints
    // branded on its first frame instead of flashing the default Dashly styling.
    // Cached origins don't wait; a cold visit waits at most a bounded time.
    const stylingReady = secureLocalStorage.getItem(StorageConstants.USER)
      ? Promise.resolve()
      : prepareUrlSpecificStyling();
    Promise.all([brandingReady, stylingReady])
      .catch(() => undefined)
      .finally(() => setReady(true));
  }, []);

  if (!ready) {
    return <div></div>;
  }

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <HashRouter>
    <AppLoader />
  </HashRouter>
);
